// extracted by mini-css-extract-plugin
module.exports = {"base":"LineBanner_base__ILd8g","sp-only":"LineBanner_sp-only__rjUcg","pc-only":"LineBanner_pc-only__yqVjm"};